export enum Layouts {
  LoggedIn,
  Minimal,
  Public,
  Auth,
}

export type LayoutMarginsType = {
  top?: number | string;
  right?: number | string;
  bottom?: number | string;
  left: number | string;
};
